module.exports = __webpack_public_path__ + "static/media/Unboxing.1e7171dd.jpg";